import { getVoyageDocRef, getVoyagesCollectionRef } from "../paths";
import { BaseFirestoreRepository } from "./BaseFirestoreRepository";

export class FirestoreVoyageRepository extends BaseFirestoreRepository {
  async upsertEntity(entity) {
    return this.upsert(
      getVoyageDocRef(this.db, entity.id),
      this.addStorageMarker(entity)
    );
  }

  async deleteEntity(entityId) {
    return this.delete(getVoyageDocRef(this.db, entityId));
  }

  async listByVesselId(vesselId) {
    return this.listByField(getVoyagesCollectionRef(this.db), "vesselId", vesselId);
  }

  async getEntity(voyageId) {
    const entity = await this.get(getVoyageDocRef(this.db, voyageId));
    return this.isManagedV2Document(entity) ? entity : null;
  }
}
